export const playlist = () => ({
  textAlign: "center",
})
